import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import './termsAndConditionsBlock.scss'
import appConfig from 'app.config'


export interface ITermsAndCondition {
	className?: string
}

const TermsAndConditionBlock = ({ className }: ITermsAndCondition) => {
	const { t } = useTranslation()

	const redirect = () => {
		switch (appConfig.country) {
			case 'lt':
				return 'https://tfbank.lt/bendrosios-elektroniniu-paslaugu-teikimo-salygos'
			default:
				return '#'
		}
	}

	return (
		<div id="terms-and-condition-content" className={`${className ?? ''}`}>
			<Trans
				t={t}
				i18nKey="LoginTermsAndConditionText"
				components={[
					<span>
						<a target="_blank" href={redirect()} rel="noreferrer">
							terms and conditions
						</a>
					</span>,
				]}
			/>
		</div>
	)
}

export default TermsAndConditionBlock
